import { Injectable } from '@angular/core';
import { PhcApp, PhcLink } from '../../classes/phc-app/phc-app';
import { ArticlePage } from '../../pages/article/article';
import { WpProvider } from '../wp/wp';
import { App, NavController, Platform } from 'ionic-angular';
import { InAppBrowser, InAppBrowserObject } from '@ionic-native/in-app-browser';
import { WebpageIframePage } from '../../pages/webpage-iframe/webpage-iframe';
import { SubmenuPage } from '../../pages/submenu/submenu';
import { GalleryPage } from '../../pages/gallery/gallery';
import { ModuleLinkProvider } from '../module-link/module-link';
import { TabUpdateProvider } from '../tab-update/tab-update.service';

/*
  Generated class for the PhcLinkServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PhcLinkServiceProvider {

  navCtrl: NavController;
  phcApp: PhcApp;
  browser: InAppBrowserObject;
  webpageIframe = WebpageIframePage;


  constructor(wp: WpProvider,
              private app: App,
              private iab: InAppBrowser,
              private platform: Platform,
              private moduleLink: ModuleLinkProvider,
              private planaday: TabUpdateProvider,
              ) {
    this.phcApp = wp.app;
    this.navCtrl = app.getActiveNav();
  }


  activateLink(link: PhcLink, navCtrl: NavController = this.navCtrl) {

    if (link.isWebpage() && link.webpageUrl) {

      if (this.platform.is('core')) {
        navCtrl.push(this.webpageIframe, { url: link.webpageUrl });
      } else {
        switch(link.webpageTarget) {
          case 'iframe':
            navCtrl.push(this.webpageIframe, { url: link.webpageUrl });
            break;
          case 'native':
            this.browser = this.iab.create(link.webpageUrl, '_system', {
              location: 'no'
            });
            break;
          default:
            this.browser = this.iab.create(link.webpageUrl, '_blank', {
              location: 'no'
            });
            break;
        }
      }
    }
    if (link.isMenu()) {
      navCtrl.push(SubmenuPage, { menuId: link.menuId });
    }
    if (link.isModule()) {
      let module = this.phcApp.getModule(link.moduleId);
      if (module.moduleKey !== 'planaday') {
        const modulePage = this.moduleLink.getModule(module.moduleKey);
        navCtrl.push(modulePage, { module: link.module });
      } else {
        const modulePage = this.moduleLink.getModule(module.moduleKey);
        this.planaday.moduleUpdates.next(link.module);
        navCtrl.push(modulePage, { module: link.module });
      }
    }

    if(link.isArticle()) {
      navCtrl.push(ArticlePage, { articleId: link.articleId });
    }
    if(link.isGallery()) {
      navCtrl.push(GalleryPage, { galleryId: link.galleryId });
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/phc-link-service/phc-link-service.ts